import { useState } from 'react';
import { Edit, Inventory2Outlined, TaskAlt } from '@mui/icons-material';
import { Box, CircularProgress, Grid2, IconButton, Tooltip } from '@mui/material';
import { ExperienceStatus } from '@utriper/core';
import { useExperienceDetail } from 'core/contexts/experienceDetail';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const Actions = ({ experienceId, experienceDetail, handleEdit = () => {} }) => {
    const { t: translate } = useTranslation();
    const { updateExperienceDetail } = useExperienceDetail();

    const [updating, setUpdating] = useState(false);

    const handleStatus = async (status) => {
        setUpdating(true);
        try {
            if (!experienceId || !experienceDetail?.id) {
                throw new Error(translate('actions_component.toasts.errors.no_valid_option'));
            }

            if (status === experienceDetail?.status) {
                throw new Error(translate('actions_component.toasts.errors.no_valid_status'));
            }

            const values = {
                status,
            };

            const result = await updateExperienceDetail(experienceId, experienceDetail?.id, values);

            if (!result) {
                throw new Error(translate('actions_component.toasts.errors.update_failed'));
            } else {
                toast.success(translate('actions_component.toasts.success.status_updated'), {
                    position: 'top-right',
                    theme: 'colored',
                });
            }
        } catch (error) {
            toast.error(error?.message || error, {
                position: 'top-right',
                theme: 'colored',
            });
        } finally {
            setUpdating(false);
        }
    };

    return (
        <Grid2 container width="fit-content" justifyContent="space-between" alignItems="center" gap="8px">
            <Tooltip title={translate('actions_component.edit')} placement="top">
                <IconButton onClick={() => handleEdit(experienceDetail)}>
                    <Edit />
                </IconButton>
            </Tooltip>
            {experienceDetail?.status !== ExperienceStatus.IDS.live ? (
                <Tooltip title={translate('actions_component.publish')} placement="top" disableHoverListener={updating}>
                    <IconButton
                        onClick={() => handleStatus(ExperienceStatus.IDS.live)}
                        sx={{ color: '#50C878' }}
                        loading={updating}
                        loadingIndicator={
                            <Box sx={{ display: 'flex' }}>
                                <CircularProgress size={20} sx={{ color: '#131313bf' }} />
                            </Box>
                        }
                    >
                        <TaskAlt />
                    </IconButton>
                </Tooltip>
            ) : (
                <Tooltip title={translate('actions_component.archive')} placement="top" disableHoverListener={updating}>
                    <IconButton
                        onClick={() => handleStatus(ExperienceStatus.IDS.archived)}
                        sx={{ color: '#E4954B' }}
                        loading={updating}
                        loadingIndicator={
                            <Box sx={{ display: 'flex' }}>
                                <CircularProgress size={20} sx={{ color: '#131313bf' }} />
                            </Box>
                        }
                    >
                        <Inventory2Outlined />
                    </IconButton>
                </Tooltip>
            )}
        </Grid2>
    );
};

export default Actions;
